// @ts-nocheck
import { Box, Typography } from "@mui/material";
import ShowPhazeLogo from "../../../assets/images/Horizontal_logo.svg";
import PropTypes from "prop-types";

export const ConsentHeaders = ({ title, subTitle }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "1.25rem",
      }}
    >
      <img src={ShowPhazeLogo} className="consent-img" />

      <Typography
        sx={{
          textAlign: "center",
        }}
      >
        512-621-6066 |{" "}
        <a className="pink-link" href="mailto:info@showphaze.com">
          info@showphaze.com
        </a>{" "}
        |{" "}
        <a
          className="pink-link"
          href="https://showphaze.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          showphaze.com
        </a>{" "}
        | 8817 Burleson Manor Rd, Manor TX 78653
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          gap: "0.5rem",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "1.75rem",
            fontWeight: "bold",
            textDecoration: "capitalze",
          }}
        >
          {title}
        </Typography>
        {subTitle && (
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: "semibold",
              textDecoration: "capitalze",
            }}
          >
            {subTitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

ConsentHeaders.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};